var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadToCloudSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "130px",
    width: "130px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-19.19 -19.19 230.31 230.31",
    xmlSpace: "preserve",
    fill: "#ffffff",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2f73bf"
    },
    points: "128.613,116.799 95.967,84.153 63.321,116.799 65.915,119.394 94.131,91.175 94.131,169.673 97.803,169.673 97.803,91.178 126.015,119.394 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f73bf"
    },
    d: "M146.597,59.445c-6.914-11.531-19.383-18.635-32.868-18.635c-3.089,0-6.199,0.387-9.262,1.152 c-6.778-12.193-19.465-19.709-33.466-19.709c-20.603,0-37.46,16.341-38.272,36.934C13.961,61.918,0,77.94,0,97.094 c0,21.13,17.189,38.319,38.319,38.319H76.58v-3.579H38.326c-19.158,0-34.74-15.586-34.74-34.74 c0-17.844,13.367-32.696,31.093-34.543l1.593-0.372v-1.61c0-19.154,15.582-34.736,34.736-34.736 c13.131,0,24.991,7.297,30.957,19.039l0.673,1.321l1.421-0.412c3.196-0.927,6.446-1.396,9.674-1.396 c12.619,0,24.268,6.871,30.395,17.934l0.648,1.167l1.303-0.286c22.268-4.914,42.273,12.279,42.273,33.895 c0,19.15-15.582,34.74-34.74,34.74H115.06v3.579h38.548c21.13,0,38.319-17.189,38.319-38.319 C191.927,73.667,170.607,54.957,146.597,59.445z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadToCloudSvgrepoCom);
export default __webpack_public_path__ + "static/media/upload-to-cloud-svgrepo-com.f6b1f1eecf98f0d6659e5706cf477bd7.svg";
export { ForwardRef as ReactComponent };